import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormControl, OutlinedInput, InputLabel } from '@material-ui/core';
import StripeInput from './StripeInput';

class StripeElementWrapper extends PureComponent {
  state = {
    empty: true,
    error: false,
    focused: false,
  };

  handleBlur = () => {
    this.setState({ focused: false });
  };

  handleFocus = () => {
    this.setState({ focused: true });
  };

  handleChange = ({ empty, error }) => {
    this.setState({
      empty,
      error,
    });
  };

  render() {
    const { component, label, labelWidth, placeholder } = this.props;

    const { empty, error, focused } = this.state;

    return (
      <div>
        <FormControl fullWidth variant="outlined">
          <InputLabel error={!!error} focused={focused} shrink={focused || !empty}>
            {label}
          </InputLabel>
          <OutlinedInput
            fullWidth
            inputComponent={StripeInput}
            inputProps={{ component }}
            labelWidth={labelWidth}
            notched={focused || !empty}
            placeholder={focused ? placeholder : ''}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onChange={this.handleChange}
          />
        </FormControl>
      </div>
    );
  }
}

StripeElementWrapper.propTypes = {
  component: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
  labelWidth: PropTypes.number,
  placeholder: PropTypes.string,
};

export default StripeElementWrapper;
